// const PERCENT = 0.036
const PERCENT = 0.0485

const ANNUAL_INTEREST_RATE = 0.6499
const ONE_TIME_COMMISSION_RATE = 0.0499

const calculateAnnuityPayment = (principal, months, annualRate, commissionRate) => {
  const loanAmount = principal * (1 + commissionRate)
  const monthlyRate = (annualRate / 360) * 30

  if (!monthlyRate) {
    return loanAmount / months
  }

  return (monthlyRate * loanAmount) / (1 - Math.pow(1 + monthlyRate, -months))
}

export const new_function_find_avarage_payment = (sum, count) => {
  return calculateAnnuityPayment(
    sum,
    count,
    ANNUAL_INTEREST_RATE,
    ONE_TIME_COMMISSION_RATE
  ) | 0
}

export const findAvarage = (sum, count) =>
  {
    return ((sum / 2) * ((2 + PERCENT * (count + 1)) / count)) | 0
  }

export const findSum = (average, count) =>
  ((2 * average * count) / (2 + PERCENT * (count + 1))) | 0

export const moneyFormatToNumber = str => +str.replace(/\s/g, "")

export function debounce(func, wait, immediate) {
  var timeout
  return function() {
    var context = this,
      args = arguments
    var later = function() {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    var callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}
